"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CompassionateCareForEveryTail() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224148" id="compassionate-care-for-every-tail" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
            {}
            <div className="absolute inset-0 z-0 pointer-events-none opacity-5">
                <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687478/img/paw_pattern_decorative.png')] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_80%_at_50%_50%,#000_30%,transparent_100%)]"></div>
            </div>

            <div className="container mx-auto px-4 md:px-6 relative z-10">
                <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
                    
                    {}
                    <div ref={textRef} className={`w-full lg:w-3/5 flex flex-col items-start space-y-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-default font-bold tracking-tight leading-[1.1] text-foreground">
                            Compassionate Care for <span className="text-chart-2">Every Tail</span>
                        </h1>
                        
                        <p className="text-[22px] leading-relaxed text-muted-foreground font-default max-w-2xl">
                            At Happy Paws Animal Hospital, we provide world-class veterinary services including vaccinations, surgery, and wellness exams to keep your furry family members healthy and happy.
                        </p>
                        
                        <div className="pt-4 flex flex-wrap gap-4">
                            <Button asChild size="lg" className="bg-chart-1 hover:bg-chart-1/90 text-white text-lg h-14 px-8 rounded-lg shadow-lg shadow-chart-1/20 transition-all duration-300 hover:shadow-chart-1/40 hover:-translate-y-1">
                                <Link to="/ContactPage">Book an Appointment</Link>
                            </Button>
                            <Button asChild variant="ghost" size="lg" className="text-chart-1 border-chart-1 hover:bg-chart-1/5 text-lg h-14 px-8 rounded-lg transition-all duration-300">
                                <Link to="#">Watch Our Story</Link>
                            </Button>
                        </div>
                    </div>

                    {}
                    <div ref={imgRef} className={`w-full lg:w-2/5 relative transition-all duration-1000 delay-200 ease-out ${isImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
                        <div className="relative rounded-3xl overflow-hidden shadow-xl shadow-slate-200/50 border border-border aspect-square lg:aspect-[4/5] bg-muted/20">
                            {}
                            <div className="absolute inset-0 bg-gradient-to-tr from-chart-2/10 to-transparent mix-blend-overlay z-10 pointer-events-none"></div>
                            
                            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687478/img/vet_hugging_golden_retriever.png" alt="Compassionate veterinarian hugging a happy Golden Retriever" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
                        </div>
                        
                        {}
                        <div className="absolute -inset-4 bg-chart-2/10 blur-3xl -z-10 rounded-lg opacity-40 pointer-events-none"></div>
                    </div>

                </div>
            </div>
        </section>;
}